import React, { Component } from 'react';
import './css/billing.css';

export default class Billing extends Component {

  constructor(props){
    super(props);

    this.state = {
      showModal: false
    };
  }

  showModal(){
    this.setState({
      showModal: true
    });
  }
  
  componentDidUpdate(){
    if (this.state.showModal){
      let $modal = window.$('.modal');
      $modal.modal();

      $modal.on('hidden.bs.modal', _ => {
        this.setState({
          showModal: false
        });
      });
    }
  }
  
  render(){

    let paymentModal = (
      <div className="modal fade">
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal">
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 className="modal-title">
                Payment Settings
              </h4>
            </div>
            <div className="modal-body">

              <div className="form-horizontal">
                <div className="form-group">
                  <label className="col-sm-2 control-label">
                    Payment Method:
                  </label>
                  <div className="col-sm-10">
                    <select className="form-control">
                      <option value="paypal">
                        <i className="fa fa-paypal"></i>
                        PayPal
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="form-horizontal">
                <div className="form-group">
                  <label className="col-sm-2 control-label">
                    Email:
                  </label>
                  <div className="col-sm-10">
                    <input type="email"
                           className="form-control"
                           placeholder="Email"/>
                  </div>
                </div>
              </div>
              
              <p>
                Please enter your first and last name as they appear on your PayPal account under the 'Profile" menu
              </p>
              
              <div className="form-horizontal">
                <div className="form-group">
                  <label className="col-sm-2 control-label">
                    First Name:
                  </label>
                  <div className="col-sm-10">
                    <input type="text"
                           className="form-control"
                           placeholder="First Name"/>
                  </div>
                </div>
                <div className="form-group">
                  <label className="col-sm-2 control-label">
                    Last Name:
                  </label>
                  <div className="col-sm-10">
                    <input type="text"
                           className="form-control"
                           placeholder="Password"/>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="modal-footer">
              <button type="button" className="btn btn-danger" data-dismiss="modal">
                Cancel
              </button>
              <button type="button"
                      className="btn btn-success">
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>
    );
    
    return (
      <div id="billing">
        <h3>Paymeny Method:
          <span className="text-danger">
            Missing
          </span>
        </h3>

        <button
          className="btn btn-primary"
          onClick={_=> this.showModal() }>
          Configure Payment Method
        </button>
        
        
        <h3>Invoices</h3>
        <table className="table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Amount</th>
              <th>Description</th>
            </tr>
          </thead>
        </table>

        <p>
          You have no invoices to review
        </p>

        {this.state.showModal && paymentModal}
      </div>
    );
    
  }
}



// WEBPACK FOOTER //
// ./src/billing.js